import type { ListSort } from "./pagination.models";
import { sortSchema } from "./pagination.models";

/**
 * Columns the wallet's credit-transaction history can be ordered by.
 *
 * `date` maps to the table's `ordinal`, not `createdAt`: the ordinal is the
 * per-team monotonic sequence the ledger is built on, so it orders identically to
 * creation time while also being unique — which makes it its own paging
 * tiebreaker.
 */
export const CREDIT_TRANSACTION_SORT_KEYS = ["date", "amount"] as const;

export const creditTransactionSortSchema = sortSchema(
  CREDIT_TRANSACTION_SORT_KEYS,
);

export type CreditTransactionSortKey =
  (typeof CREDIT_TRANSACTION_SORT_KEYS)[number];
export type CreditTransactionSort = ListSort<CreditTransactionSortKey>;

/** Newest-first, which is the ordering the history has always applied. */
export const DEFAULT_CREDIT_TRANSACTION_SORT: CreditTransactionSort = {
  key: "date",
  direction: "desc",
};
